import React from 'react';
import { Badge as UiBadge } from '@components/ui/badge';
import { cn } from '@core/utils/cn';

export type BadgeType = 'green' | 'red' | 'grey' | 'blue' | 'yellow';

interface BadgeProps {
    type?: BadgeType;
    size?: 'small' | 'medium';
    children?: string;
}

const variants = {
    green: 'success',
    red: 'destructive',
    yellow: 'warning',
    grey: 'muted',
    blue: 'info'
} as const;

const dotColors = {
    green: 'bg-success',
    red: 'bg-destructive',
    yellow: 'bg-warning',
    grey: 'bg-muted-foreground',
    blue: 'bg-info'
} as const;

export function BadgeDot({
    type,
    className
}: {
    type?: BadgeType;
    className?: string;
}) {
    return (
        <span
            aria-hidden="true"
            className={cn(
                'size-2 shrink-0 rounded-full',
                type ? dotColors[type] : 'bg-muted-foreground',
                className
            )}
        />
    );
}

export function Badge(props: BadgeProps) {
    if (!props.children) {
        return null;
    }

    return (
        <UiBadge
            variant={props.type ? variants[props.type] : 'secondary'}
            className={cn(props.size === 'medium' && 'px-3 py-1 text-sm')}
        >
            {props.children.toUpperCase()}
        </UiBadge>
    );
}
